import React, { useEffect, useCallback, useState} from 'react';
import TracksDropdown from 'components/dropdowns/TracksDropdown.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {connect} from 'react-redux';

const FollowerComponent = ({effect, sequencerEngine}) => { 
    return (
        <div>
          <TracksDropdown
            track={effect.getTrack()}
            onSelectTrack={(track) => {
                if (!track) {
                    effect.trackParameter.set(-1);
                } else {
                    effect.trackParameter.set(track.trackNumber);
                }}} 
            sequencerEngine={sequencerEngine}/>
          <EffectParameterSlider
            name='Roughness'
            lfoEnabled={true}
            parameter={effect.roughnessParameter}
            isParameter={true}
            step={0.1}
            max={100}
            min={0.1}
          />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FollowerComponent);
